export default "__VITE_ASSET__c783c243__"